const configuredApiBase = process.env.API_BASE_URL || 'https://moe-pi.ddns.net:8484';

export const API_BASE_URL = configuredApiBase.replace(/\/$/, '');
export const PUBLIC_API_TOKEN = process.env.PUBLIC_API_TOKEN || '';

export function publicApiHeaders(extraHeaders = {}) {
  return {
    Authorization: `Bearer ${PUBLIC_API_TOKEN}`,
    ...extraHeaders
  };
}
